var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-us"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.aboutUsData)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }